<template>
  <div class="gardens-page">
    <!-- 切换按钮 - 参考 IndoorVr.vue 样式 -->
    <div class="navlist">
      <div
        class="item"
        :class="{ active: currentView === 'vr' }"
        @click="switchView('vr')"
      >
        下沉庭院
      </div>
      <div
        class="item"
        :class="{ active: currentView === 'video' }"
        @click="switchView('video')"
      >
        核心景观
      </div>
    </div>

    <!-- VR iframe -->
    <iframe
      v-if="currentView === 'vr'"
      class="iw-html-frame"
      scrolling="no"
      :src="vrUrl"
    ></iframe>

    <!-- 视频播放器 -->
    <video
      v-if="currentView === 'video'"
      class="video-player"
      :src="videoUrl"
      :poster="videoPoster"
      controls
      autoplay
      muted
      loop
      playsinline
    ></video>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentView: 'vr', // 默认显示 VR
      vrUrl: 'https://www.720yun.com/vr/c54jtdkwuu7',
      videoUrl: 'http://720yun.unrealera.com/video/dichang/huaishanwang/jinguan.mp4',
      videoPoster: 'http://720yun.unrealera.com/video/dichang/huaishanwang/jinguan.mp4?vframe/png/offset/0'
    };
  },
  mounted: function() {},
  methods: {
    switchView(viewType) {
      this.currentView = viewType;
    }
  }
};
</script>

<style lang="scss" scoped>
.gardens-page {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

.navlist {
  background: rgba(0, 0, 0, 0.6);
  position: absolute;
  padding: 10px;
  left: 50%;
  transform: translateX(-50%);
  top: 20px;
  z-index: 9999;
  border-radius: 18px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  gap: 10px;

  .item {
    line-height: 28px;
    height: 28px;
    text-align: center;
    color: #fff;
    cursor: pointer;
    padding: 0 20px;
    white-space: nowrap;
    transition: all 0.3s ease;

    &:hover {
      color: #d5bda6;
    }
  }

  .active {
    color: #d5bda6;
  }
}

.iw-html-frame {
  width: 100%;
  height: 100%;
  border: none;
}

.video-player {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
}
</style>




// WEBPACK FOOTER //
// src/pages/Gardens.vue